import styled from 'styled-components';
import Distance from './Distance';

export default styled(Distance)`
  display: inline;
  .distance {
    display: inline;
  }
`;
